export default "__VITE_ASSET__17a67fbe__"